import React from "react";
import { Link } from "react-router-dom";

export default function PageNotFound() {
  return (
    <div className="flex h-screen w-full border items-center justify-center">
      <div className="mb-8 text-center">
        <h1 className="text-2xl mb-3">404 page not found</h1>
        <Link to="/" className="text-blue-900 underline">
          Back to home
        </Link>
      </div>
    </div>
  );
}
